import {Urls} from '../constants'
import { waitForElem } from "../utils/waitForElem.js";

(function () {
    /* global $ */
    "use strict";

    const authSettings = $.sc.authSettings;


    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
    
        },

        adjustDom: function () {

            function getContrast(){
                var contrastMode = 	localStorage.getItem('contrast', contrastMode);

				if (contrastMode === 'normal') {
					$('body').removeClass('contrast');
				} else if (contrastMode === 'contrast') {
					$('body').addClass('contrast');
				}
            }

            // Suggest a change
            // Retrieve the value of session storage "suggestChange"
            const suggestChangeValue = sessionStorage.getItem("suggestChangeHants");

            waitForElem(".pcg-navigation__list li").then(() => {
                // Adjust menu
                if ( $.sc.authSettings.login !== null ) {

                    const firstName = $.sc.authSettings.name.split(' ');
                    const fullName = $.sc.authSettings.name;
                    // if ( $.sc.authSettings.isEmployee == true || $.sc.authSettings.isEmployer == true) {
                        // $('.pcg-navigation__list li').eq(1).after(
                        $('.pcg-navigation__list').append(
                            `
                                <li class="pcg-navigation__item" style="position: relative">
                                    <a href="/s4s/CustomPage/Index/${Urls.dashboard_hants}" class="pcg-navigation__link pcg-contrast__link">Dashboard</a>
                                    <div class="shortlist-notification-container js-shortlist-notification-container" style="display: none">
                                        <div class="shortlist-notification-triangle"></div>
                                        <button class="js-shortlist-notification-message shortlist-notification-message">
                                            Added to My Shortlist
                                        </button> 
                                    </div>
                                </li>
                                <li class="pcg-navigation__item">
                                    <a href="/s4s/CustomPage/Index/${Urls.page_hants_messages}" class="pcg-navigation__link pcg-contrast__link">Messages</a>
                                </li>
                            `
                        )
                    // } 
                    
    
                    // $('.pcg-navigation__list').append(
                    //     `
                    //         <li class="pcg-navigation__item">
                    //             <a href="/s4s/CustomPage/Index/${Urls.page_hants_messages}" class="pcg-navigation__link pcg-contrast__link">Messages</a>
                    //         </li>
                    //     `
                    // )

                    $('.pcg-user').html(`
						<a class="pcg-user__link pcg-contrast__link logged" href="/s4s/MyProfile/MyProfileTab">Hello, ${fullName}</a>
						<a class="pcg-user__link pcg-contrast__link logged" href="/s4s/Auth/Logout?ReturnUrl=/">Log out</a>
					`)
                }
            });
            
			

			// Form styling
			if(window.location.href.indexOf('/s4s/EventAdministrationDetailsPublic/CreateDirectory?templateId=8b5b3e03-346c-4098-bfc9-b0cb0106b267') > -1) {

                

                waitForElem("#EventDetailsImageUpload_ImageUploaded").then(() => {
                    $('body').addClass('createEvent');
                    $('#maincontent').addClass('container')
                    // $('.actionButtons').parent().parent().prepend('<ul><li><h2>Create Event</h2></li></ul>')
                    
                // setTimeout(function () {

                    $('.isSelectedAll').each(function () {
                        $(`<label for="${$(this).attr('id')}" class="isSelectedAll-label">Select all</label>`).insertAfter($(this));
                    });

                    $('.attributeChildCb').each(function () {
                        $(this).addClass(`${$(this).parent().attr('id')}`)
                    });

                    $('.amendArrow').each(function () {
                        $(this).parent().addClass('amendArrow-attributes');
                    });

                    $('label').each(function () {

                        if ($(this).text() === 'Local authority name:') {
                            $(this).parent().parent().parent().parent().hide();
                        }

                        if ($(this).text() === 'Category:') {
                            $(this).parent().parent().parent().parent().parent().parent().hide();
                        }

                    });

                    $('label[for=Name]').html('PA Username:<span class="required-asterisk">*</span>');

                    $('legend').each(function () {

                        if ($(this).text() === 'Directory image (list):') {
                            $(this).text('Upload a profile photo')
							$(this).parent().parent().parent().parent().parent().parent().parent().append('<li style="font-size: inherit;margin-left: 20px;font-weight: 600; margin-top: 2rem; font-family: &quot;Open Sans&quot;, Arial, sans-serif;">Please scroll to the top of the form to save/submit.</li>')

                        }                     

                    })

					$('#mceu_21').prev().text('Additional Information:')

                    $('h2.lhs strong').each(function () {

                        if ($(this).text() === 'Attributes') {
                            $(this).text('Details')
                            $(this).addClass('green-wrapper')
                                $(this).parent().css('width','100%')
                        }

                    });

                    $('h2').each(function () {

                        if ($(this).text() === 'User') {
                            $(this).html('<p style="font-size: 1rem;">Click on the <i class="fa fa-plus-square" aria-hidden="true"></i> icons to expand all options, select the filter options that are relevant to you to help users find you on Hampshire PA Finder.</p>')
                            $(this).parent().addClass('user-attributes')
                        }

                    });

                    $('.repeating-schedule__label').parent().parent().parent().hide();    

					$('.js-is-published').addClass('publishedSection')
                    $('.js-is-published').prev().addClass('publishedSection')
                    $('.js-is-published').parent().css('display','flex')
                    $('.js-is-published').parent().css('margin-left','10px')
                    $('.js-publish-date').addClass('publishedSection')
                    $('.js-publish-date').prev().addClass('publishedSection')
                    $('.js-publish-date').parent().css('display','flex')
                    $('.js-publish-date').parent().css('margin-left','10px')              

                    $('.amendArrow-right').css('border', 'none').css('margin-right', '10px').html('<i class="fa fa-plus-square" aria-hidden="true" tabindex="0"></i>');
                    $('.amendAttributeHead').css('margin-left', '20px');


                    //Add or remove + and - icons from 'Lincs'
                    $('body').on('click', '.amendArrow', function (e) {
                        if ($(this).children().hasClass('fa-plus-square')) {
                            $(this).children().removeClass('fa-plus-square');
                            $(this).children().addClass('fa-minus-square');
                        } else if ($(this).next().next().next().html() === "Deselect all") {
                            e.stopPropagation();
                        } else {
                            $(this).children().addClass('fa-plus-square');
                            $(this).children().removeClass('fa-minus-square');
                        }
                    });

                    $('body').on('keypress', '.amendArrow', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });

                    //Select and Deselect All 
                    $('body').on('click', '.isSelectedAll', function () {
                        //Add - icon on 'Lincs' when select all checkbox is checked
                        if ($(this).next().html() === "Select all") {
                            if ($(this).prev().prev().children().hasClass('fa-plus-square')) {
                                $(this).prev().prev().children().removeClass('fa-plus-square');
                                $(this).prev().prev().children().addClass('fa-minus-square');
                            }
                        }
                        //Change the text inside of 'Select all' label
                        if ($(this).is(':checked')) {
                            $(this).next().html("Deselect all");
                        } else {
                            $(this).next().html("Select all");
                        }
                    });

                    $('body').on('keypress', '.isSelectedAll', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });


                    //Check and uncheck attributes
                    $('body').on('click', '.attributeChildCb', function () {
                        let checkboxesCounter = 0;
                        let idAttribute = $(this).parent().attr('id');
                        let selectAllChecboxTick = $(this).parent().parent().children()[2];
                        let selectAllCheckbox = $(this).parent().parent().children()[3];
                        let checkboxesNumber = document.getElementsByClassName(idAttribute);

                        for (let i = 0; i < checkboxesNumber.length; i++) {
                            if ($(checkboxesNumber[i]).is(':checked')) {
                                checkboxesCounter++;
                                //Check if all the attributes' checkboxes are checked
                                if (checkboxesCounter === checkboxesNumber.length) {
                                    selectAllCheckbox.innerText = "Deselect all";
                                    selectAllChecboxTick.checked = true;
                                } else {
                                    selectAllCheckbox.innerText = "Select all";
                                }
                            }
                        }

                    });

                    $('body').on('keypress', '.attributeChildCb', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });

                    $('.js-accordion-body ul').css('display','')

                    $('.js-event-details__geolocation').hide();

                    // Remove 'New PA Finder -' from attributes' name
                    $('.amendAttributeHead').each(function() {
                        var $element = $(this);
                        var currentText = $element.text();
                        var updatedText = currentText.replace('New PA Finder -', '');
                        $element.text(updatedText);
                    });

                    // Hide 'Select all' for certain attributes
                    $('.amendAttributeHead').each(function() {
                        if ($(this).text() === ' Do you have a the right to work in the UK?') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Do you have a Valid UK Full Licence?') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' My Gender') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Will work as part of a team  (i.e. more than 1 PA at the same time)') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Days out and support with social activities') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Experience') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Hours') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Languages I speak') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' My hobbies and interests') {
                            $(this).parent().addClass('other-container')
                        }

                    })

                    $('label').each(function() {
                        if ($(this).text() === 'Other') {
                            $(this).parent().addClass('other-option')
                        }
                    })


                    //Remove body
                    $('.js-overlay-body').remove();

                // }, 1000);
                })

                

            }


            if(window.location.href.indexOf('/s4s/EventAdministrationDetailsPublic/CreateDirectory?templateId=aa858171-e78d-47ce-a48f-b0ca00ab09a6') > -1 || (window.location.href.indexOf('/s4s/EventAdministrationDetailsPublic/CreateDirectory?templateId=b9b8c97c-7599-4a80-b00f-b13800bf4518') > -1)) {
                
                
                waitForElem("#mceu_21").then(() => {
                    // Redirect on submit/finish
                    $('body').on('click', '.submitWithChangingAction', function () {
                        window.location.href = "/s4s/CustomPage/Index/" + Urls.info_hants;
                    })
                })
            }

			if (window.location.href.indexOf('/s4s/EventWizard/MainDetails') > -1) {
                waitForElem(".supportPackage-steps").then(() => {
                    $("label[for='OrganisationIdString']").parent().hide();
                })
            }

            if(window.location.href.indexOf('/s4s/EventWizard/AdditionalInformation') > -1) {
                waitForElem("#mceu_21").then(() => {
                     // Hide 'Select all' for certain attributes
                     $('.amendAttributeHead').each(function() {
                        if ($(this).text() === ' Will work as part of a team  (i.e. more than 1 PA at the same time)') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Days out and support with social activities') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Experience') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Hours') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Languages I speak') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' My hobbies and interests') {
                            $(this).parent().addClass('other-container')
                        }

                        
                    })

                    $('label').each(function() {
                        if ($(this).text() === 'Other') {
                            $(this).parent().addClass('other-option')
                        }
                    })

                    $('legend').each(function () {

                        if ($(this).text() === 'Directory image (list):') {
							$(this).parent().parent().parent().parent().parent().prepend('<li style="font-size: inherit;margin-left: 20px;font-weight: 600; margin-top: 2rem; font-family: &quot;Open Sans&quot;, Arial, sans-serif;">Please upload your image to both of these fields to display on the search page and profile page.</li>')

                        }                     

                    })

                    
                })

                               
            }
		

			if (window.location.href.indexOf('/s4s/EventAdministrationDetailsPublic/Index') > -1) {


                waitForElem("#EventDetailsImageUpload_ImageUploaded").then(() => {

                    $('body').addClass('createEvent');
                    $('#maincontent').addClass('container')
                    $('title').text('Suggest a change');
                    // $('.actionButtons').parent().parent().prepend('<ul><li><h2>Create Event</h2></li></ul>')
                    
                // setTimeout(function () {

                    $('.isSelectedAll').each(function () {
                        $(`<label for="${$(this).attr('id')}" class="isSelectedAll-label">Select all</label>`).insertAfter($(this));
                    });

                    $('.attributeChildCb').each(function () {
                        $(this).addClass(`${$(this).parent().attr('id')}`)
                    });

                    $('.amendArrow').each(function () {
                        $(this).parent().addClass('amendArrow-attributes');
                    });

                    $('label').each(function () {

                        if ($(this).text() === 'Local authority name:') {
                            $(this).parent().parent().parent().parent().hide();
                        }

                        if ($(this).text() === 'Category:') {
                            $(this).parent().parent().parent().parent().parent().parent().hide();
                        }

                    });


                    $('legend').each(function () {

                        if ($(this).text() === 'Directory image (list):') {
                            $(this).text('Upload a profile photo')
							$(this).parent().parent().parent().parent().parent().parent().parent().prepend('<li style="font-size: inherit;margin-left: 20px;font-weight: 600; margin-top: 2rem; font-family: &quot;Open Sans&quot;, Arial, sans-serif;">Please upload your image to both of these fields to display on the search page and profile page.</li>')
							$(this).parent().parent().parent().parent().parent().parent().parent().append('<li style="font-size: inherit;margin-left: 20px;font-weight: 600; margin-top: 2rem; font-family: &quot;Open Sans&quot;, Arial, sans-serif;">Please scroll to the top of the form to save/submit.</li>')

                        }                     

                    })

					$('#mceu_21').prev().text('Additional Information:')

                    $('h2.lhs strong').each(function () {

                        if ($(this).text() === 'Attributes') {
                            $(this).text('Details')
                            $(this).addClass('green-wrapper')
                                $(this).parent().css('width','100%')
                        }

                    });

                    $('h2').each(function () {

                        if ($(this).text() === 'User') {
                            $(this).html('<p style="font-size: 1rem;">Click on the <i class="fa fa-plus-square" aria-hidden="true"></i> icons to expand all options, select the filter options that are relevant to you to help users find you on Hampshire PA Finder.</p>')
                            $(this).parent().addClass('user-attributes')
                        }

                    });

                    $('.repeating-schedule__label').parent().parent().parent().hide();    

					$('.js-is-published').addClass('publishedSection')
                    $('.js-is-published').prev().addClass('publishedSection')
                    $('.js-is-published').parent().css('display','flex')
                    $('.js-is-published').parent().css('margin-left','10px')
                    $('.js-publish-date').addClass('publishedSection')
                    $('.js-publish-date').prev().addClass('publishedSection')
                    $('.js-publish-date').parent().css('display','flex')
                    $('.js-publish-date').parent().css('margin-left','10px')              

                    $('.amendArrow-right').css('border', 'none').css('margin-right', '10px').html('<i class="fa fa-plus-square" aria-hidden="true" tabindex="0"></i>');
                    $('.amendAttributeHead').css('margin-left', '20px');


                    $('.actionButtons').before(
                        '<ul class="account intro-title-section" style="padding: 3rem 1rem 1rem">' +

                            '<h1 tabindex="0" style="font-size: 2rem">Suggest a change</h1>' +

                        '</ul>'
                    )

                    $('legend').each(function () {
                       if ($(this).text() === 'Hourly rate:') {
                           $(this).parent().addClass('hourly-fieldset')
                           $(this).parent().parent().css('padding-left','0')
                           $('.js-inline-tiny-mce').addClass('hourly-input')
                       }   

                   })

                   $("legend:contains('Description:')").text('About me:')

                   $('label[for=Name]').html('Username:<span class="required-asterisk">*</span>');
                   $('label[for=OrganisationName]').parent().hide();
                   $('label[for=Address]').parent().hide();
                   $('label[for=Postcode]').parent().hide();
                   $('label[for=Phone]').parent().hide();
                   $('label[for=Website]').parent().hide();
                   $("legend:contains('Custom field:')").parent().parent().parent().hide();
                    $('#IsPublished').prev().text('Tick to request profile published on site:')


                    //Add or remove + and - icons from 'Lincs'
                    $('body').on('click', '.amendArrow', function (e) {
                        if ($(this).children().hasClass('fa-plus-square')) {
                            $(this).children().removeClass('fa-plus-square');
                            $(this).children().addClass('fa-minus-square');
                        } else if ($(this).next().next().next().html() === "Deselect all") {
                            e.stopPropagation();
                        } else {
                            $(this).children().addClass('fa-plus-square');
                            $(this).children().removeClass('fa-minus-square');
                        }
                    });

                    $('body').on('keypress', '.amendArrow', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });

                    //Select and Deselect All 
                    $('body').on('click', '.isSelectedAll', function () {
                        //Add - icon on 'Lincs' when select all checkbox is checked
                        if ($(this).next().html() === "Select all") {
                            if ($(this).prev().prev().children().hasClass('fa-plus-square')) {
                                $(this).prev().prev().children().removeClass('fa-plus-square');
                                $(this).prev().prev().children().addClass('fa-minus-square');
                            }
                        }
                        //Change the text inside of 'Select all' label
                        if ($(this).is(':checked')) {
                            $(this).next().html("Deselect all");
                        } else {
                            $(this).next().html("Select all");
                        }
                    });

                    $('body').on('keypress', '.isSelectedAll', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });


                    //Check and uncheck attributes
                    $('body').on('click', '.attributeChildCb', function () {
                        let checkboxesCounter = 0;
                        let idAttribute = $(this).parent().attr('id');
                        let selectAllChecboxTick = $(this).parent().parent().children()[2];
                        let selectAllCheckbox = $(this).parent().parent().children()[3];
                        let checkboxesNumber = document.getElementsByClassName(idAttribute);

                        for (let i = 0; i < checkboxesNumber.length; i++) {
                            if ($(checkboxesNumber[i]).is(':checked')) {
                                checkboxesCounter++;
                                //Check if all the attributes' checkboxes are checked
                                if (checkboxesCounter === checkboxesNumber.length) {
                                    selectAllCheckbox.innerText = "Deselect all";
                                    selectAllChecboxTick.checked = true;
                                } else {
                                    selectAllCheckbox.innerText = "Select all";
                                }
                            }
                        }

                    });

                    $('body').on('keypress', '.attributeChildCb', function (e) {
                        if (e.which === 13 || e.keyCode === 13) { // Check if Enter key is pressed
                            $(this).trigger('click'); // Simulate a click event
                        }
                    });

                    $('.js-accordion-body ul').css('display','')

                    $('.js-event-details__geolocation').hide();

                    // Remove 'New PA Finder -' from attributes' name
                    $('.amendAttributeHead').each(function() {
                        var $element = $(this);
                        var currentText = $element.text();
                        var updatedText = currentText.replace('New PA Finder -', '');
                        $element.text(updatedText);
                    });

                    // Hide 'Select all' for certain attributes
                    $('.amendAttributeHead').each(function() {
                        if ($(this).text() === ' Do you have a the right to work in the UK?') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Do you have a Valid UK Full Licence?') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' My Gender') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Will work as part of a team  (i.e. more than 1 PA at the same time)') {
                            $(this).next().hide()
                            $(this).next().next().hide()
                        }

                        if ($(this).text() === ' Days out and support with social activities') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Experience') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Hours') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' Languages I speak') {
                            $(this).parent().addClass('other-container')
                        }

                        if ($(this).text() === ' My hobbies and interests') {
                            $(this).parent().addClass('other-container')
                        }

                    })

                    $('label').each(function() {
                        if ($(this).text() === 'Other') {
                            $(this).parent().addClass('other-option')
                        }
                    })
                    //Remove body
                    $('.js-overlay-body').remove();

                // }, 1000);
                })


                if (suggestChangeValue === 'vacancy') {
                    $("legend:contains('Additional information:')").parent().parent().parent().show();
                    $('label[for=Email]').parent().hide();
                    $("legend:contains('Spare 1:')").parent().hide();
                    $("legend:contains('Spare 2:')").parent().hide();
                    $("legend:contains('Spare 3:')").parent().hide();
                    $("legend:contains('Spare 4:')").parent().hide();
                    $("legend:contains('Username:')").parent().hide();
                    $("legend:contains('Full name:')").parent().hide();
                    $('#AdditionalFieldsListModel_Fields_2__Name').parent().hide();
                    $('#AdditionalFieldsListModel_Fields_3__Name').parent().hide();
                    $('#AdditionalFieldsListModel_Fields_4__Name').parent().hide();
                    $('#AdditionalFieldsListModel_Fields_5__Name').parent().hide();
                    $('#AdditionalFieldsListModel_Fields_6__Name').parent().hide();
                    $('#AdditionalFieldsListModel_Fields_8__Name').parent().hide();


                } else if (suggestChangeValue === 'pa'){
                    $("legend:contains('Additional information:')").parent().parent().parent().hide();
                }
				

                // Redirect on submit/finish
                $('body').on('click', '.submitWithChangingAction', function () {
                    window.location.href = "/s4s/CustomPage/Index/" + Urls.info_hants;
                })

			}

			 if (window.location.href.indexOf('/s4s/MyProfile/MyProfileTab') > -1) {
				setTimeout(function () {
					$('body').addClass('myProfileTab');  
                    if ( $.sc.authSettings.isEmployee == true ||  $.sc.authSettings.isEmployer == true){
                        $("legend:contains('Date of birth:')").parent().parent().parent().hide();
                        $('.js-change-my-address-button').parent().parent().parent().hide();
                        $('label[for=Position]').parent().parent().hide();

                    }
                    //Remove body
                    $('.js-overlay-body').remove();

			   	}, '500')
                waitForElem("#actionButtons li").then(() => {
                    $('[action="EditPrivateDataTab"]').text('Change password')
                })
            
			 }		 	

			// AUTH Login / Sign Up //
			if (window.location.href.indexOf('/s4s/Auth?ReturnUrl=/s4s/CustomPage/Index') > -1) {
				// Add class to page
				$('body').addClass('auth-page');		
			}


            if (window.location.href.indexOf('/s4s/SignUp/PersonalDetails') > -1) {
                getContrast();	
			}

            


            // Contrast for Direct Provider Registration
            function checkContrastFile() {
                if((window.location.href.indexOf(`/s4s/CustomPage/Index/${Urls.direct_provider_registration_hants}`) > -1) || (window.location.href.indexOf(`/s4s/CustomPage/Index/${Urls.direct_provider_registration_hants}`) > -1)){
                    if (localStorage.getItem("contrast") === 'normal') {
                        // console.log(localStorage.getItem("contrast"))
                        $('.directProviderRegistration .form-header').each(function() {
                            this.style.setProperty('background', '#fff', 'important');
                        });
                        $('.directProviderRegistration strong').each(function() {
                            this.style.setProperty('color', '#000', 'important');
                        });
                        $('.directProviderRegistration .characters-countdown-input_label').each(function() {
                            this.style.setProperty('color', '#000', 'important');
                        });
                        
                        $('.forms-mandatory').each(function() {
                            this.style.setProperty('color', '#EB0000', 'important');
                        });

                        $('.directProviderRegistration .form-navigation-btns__container').each(function() {
                            this.style.setProperty('background', '#F1EDEE', 'important');
                        });

                        $('.directProviderRegistration .form-main__questions-container').each(function() {
                            this.style.setProperty('background', '#fff', 'important');
                        });

                        $('.pcgf-default .form-navigation-btns__container button').each(function() {
                            this.style.setProperty('background', '#008485', 'important');
                            this.style.setProperty('color', '#fff', 'important');
                            this.style.setProperty('border', 'none', 'important');
                        });

                        $('.directProviderRegistration .form-body h2').each(function() {
                            this.style.setProperty('background', '#008485', 'important');
                            this.style.setProperty('color', '#fff', 'important');
                            this.style.setProperty('border', 'none', 'important');
                        });

                        $('legend').each(function() {
                            this.style.setProperty('color', '#333', 'important');
                        });

                        $('input').each(function() {
                            this.style.setProperty('background', '#fff', 'important');
                            this.style.setProperty('color', '#000', 'important');
                            this.style.setProperty('border', '1px solid #ccc', 'important');
                        });

                        $('.pcgf-default .navigation-bar__item__inner-progress').each(function() {
                            this.style.setProperty('background', '#fff', 'important');
                        });

                        $('.pcgf-default .navigation-bar__item__icon-holder i').each(function() {
                            this.style.setProperty('border', '3px solid #c4c1b6', 'important');
                            this.style.setProperty('background', '#fff', 'important');
                        });

                        $('.directProviderRegistration .navigation-bar__item_visited .navigation-bar__item__icon-holder i').each(function() {
                            this.style.setProperty('background', '#f0f0f0', 'important');
                        });

                        $('.pcgf-default .navigation-bar__progress-line').each(function() {
                            this.style.setProperty('border', '2px solid #ccc', 'important');
                            this.style.setProperty('background-color', '#fff', 'important');
                        });

                        $('.directProviderRegistration .question-type-label p > div > p:first-child').each(function() {
                            this.style.setProperty('color', '#fff', 'important');
                            this.style.setProperty('background-color', '#037470', 'important');
                        });

                        $('.css-1pahdxg-control').each(function() {
                            this.style.setProperty('background-color', '', 'important');
                        });

                        $('.css-1uccc91-singleValue').each(function() {
                            this.style.setProperty('color', '', 'important');
                        });

                        $('.css-yk16xz-control').each(function() {
                            this.style.setProperty('border-color', '', 'important');
                            this.style.setProperty('background-color', '', 'important');
                        });

                        $('.pcgf-control__react-select__menu').each(function() {
                            this.style.setProperty('color', '', 'important');
                            this.style.setProperty('background-color', '', 'important');
                        });

                        $('.directProviderRegistration .question-type-label p a').each(function() {
                            this.style.setProperty('color', '#004a80', 'important');
                        });


                    } else if (localStorage.getItem("contrast") === 'contrast') {
                        // console.log(localStorage.getItem("contrast"))
                        $('.directProviderRegistration .form-header').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                        });
                        $('.directProviderRegistration strong').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });
                        $('.directProviderRegistration .characters-countdown-input_label').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });
                        $('.forms-mandatory').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });

                        $('.directProviderRegistration .form-navigation-btns__container').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                        });

                        $('.directProviderRegistration .form-main__questions-container').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                        });

                        $('.pcgf-default .form-navigation-btns__container button').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                            this.style.setProperty('color', '#ff0', 'important');
                            this.style.setProperty('border', '2px solid #ff0', 'important');
                        });

                        $('.directProviderRegistration .form-body h2').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                            this.style.setProperty('color', '#ff0', 'important');
                            this.style.setProperty('border', '2px solid #ff0', 'important');
                        });

                        $('legend').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });

                        $('input').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                            this.style.setProperty('color', '#ff0', 'important');
                            this.style.setProperty('border', '2px solid #ff0', 'important');
                        });

                        $('.pcgf-default .navigation-bar__item__inner-progress').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                        });

                        $('.pcgf-default .navigation-bar__item__icon-holder i').each(function() {
                            this.style.setProperty('border', '3px solid #ff0', 'important');
                            this.style.setProperty('background', '#ff0', 'important');
                        });

                        $('.directProviderRegistration .navigation-bar__item_visited .navigation-bar__item__icon-holder i').each(function() {
                            this.style.setProperty('background', '#000', 'important');
                        });

                        $('.pcgf-default .navigation-bar__progress-line').each(function() {
                            this.style.setProperty('border', '2px solid #ff0', 'important');
                            this.style.setProperty('background-color', '#000', 'important');
                        });

                        $('.directProviderRegistration .question-type-label p > div > p:first-child').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                            this.style.setProperty('background-color', '#000', 'important');
                        });

                        $('.directProviderRegistration .question-type-label p a').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });

                        $('.css-1pahdxg-control').each(function() {
                            this.style.setProperty('background-color', '#000', 'important');
                        });

                        $('.css-1uccc91-singleValue').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                        });

                        $('.css-yk16xz-control').each(function() {
                            this.style.setProperty('border-color', '#ff0', 'important');
                            this.style.setProperty('background-color', '#000', 'important');
                        });

                        $('.pcgf-control__react-select__menu').each(function() {
                            this.style.setProperty('color', '#ff0', 'important');
                            this.style.setProperty('background-color', '#000', 'important');
                        });

                        $('.pcgf-control__react-select__menu')
                        .mouseenter(function() {
                            $(this).css({
                            'color': '#000',
                            'background-color': '#ff0'
                            });
                        })
                        .mouseleave(function() {
                            $(this).css({
                            'color': '#ff0',
                            'background-color': '#000'
                            });
                        });
                        
                    }
                }
            
                
            }

            if (window.location.href.indexOf(`/s4s/CustomPage/Index/${Urls.direct_provider_registration_hants}`) > -1) {
                waitForElem(".form-header__description").then(() => {

                    $('.form-header').html('');
                    $('.form-header').html(`<div class="form-header__action-buttons"></div>
                        <h1 class="form-header__title">PA Registration</h1>
                        <h2 class="form-header__description">
                            This form is for Personal Assistants to search jobs and advertise on the Hampshire PA Finder website. </br></br>

                            Please check your spam / junk email folder to verify your account.</br></br>

                            By registering to use this website you are agreeing to our <a href="https://www.hampshirepafinder.org.uk/terms-and-conditions/">Terms and Conditions</a> & <a href="https://www.hampshirepafinder.org.uk/privacy-notice-for-advert-and-vacancy-registration/">Privacy Notice</a>. You should read these carefully before continuing with your registration. It is also very important that you read the information pages relating to employing or becoming a PA and understand your legal responsibilities, especially in relation to areas such as <a rel="noopener" target="_blank" href="https://www.gov.uk/employers-checks-job-applicants">Right to Work</a>. </br></br>

                            We also recommend that you read our guidance on <a href="https://www.hampshirepafinder.org.uk/staying-safe-online/">Staying Safe Online</a>. </br></br>

                            Please note: All information provided in this form will be displayed in your profile on the website, unless stated otherwise.
                        </h2>
                    `)

                    setTimeout(function() {
                        checkContrastFile()
                    }, 500); 
                    
                        
                    $('body').click(function() {
                        checkContrastFile()
                    })  

                    getContrast();
                })
            }

            


            $('body').on('click', '.js-accessibility-widget__contrast', function(e) {
				e.preventDefault();
				var contrastMode = $(this).data('contrast');
				localStorage.setItem('contrast', contrastMode);
				if (contrastMode === 'normal') {
					$('body').removeClass('contrast');
				} else if (contrastMode === 'contrast') {
					$('body').addClass('contrast');
				}
				checkContrastFile();
				// checkContrastCreateEvent();
			});


            waitForElem("#skip_to_main_content").then((element) => {
                $(element).attr('href', '#maincontent');
            });

            waitForElem(".supportSteps h2").then((element) => {
                $(element).remove();
                $('.supportSteps').prepend('<h1>Sign up steps</h1>')
            });
   
        },

        bindUIActions: function () {
  	
        },

        unload: function () {},
    };

    Attributes.init();
})();